import { Card, Typography } from "@mui/material";
import { memo, useMemo } from "react";

interface KeyInData {
  today?: {
    waiting_support?: number;
    waiting_qc_call?: number;
  };
  today_qty?: {
    waiting_support?: number;
    waiting_qc_call?: number;
  };
  all_time?: {
    waiting_support?: number;
    waiting_qc_call?: number;
  };
  all_time_qty?: {
    waiting_support?: number;
    waiting_qc_call?: number;
  };
  tomorrow?: {
    waiting_support?: number;
    waiting_qc_call?: number;
  };
}

interface ComponentProps {
  isTask: boolean;
  data: KeyInData;
}

// Shared card styles
const cardStyle = {
  border: "1px solid #ccc",
  borderRadius: "4px",
  padding: "16px",
};

// Helper function to safely get total waiting count
const getTotalWaiting = (
  data: { waiting_support?: number; waiting_qc_call?: number } = {},
) => {
  return (data.waiting_support || 0) + (data.waiting_qc_call || 0);
};

const KeyIn = memo(({ isTask, data }: ComponentProps) => {
  const { todayCount, yesterdayCount } = useMemo(() => {
    // Calculate today's count
    const todayData = isTask ? data?.today : data?.today_qty;
    const todayCount = getTotalWaiting(todayData);

    // Calculate yesterday's count (all_time - today - tomorrow)
    const allTimeData = isTask ? data?.all_time : data?.all_time_qty;
    const tomorrowData = data?.tomorrow;

    const allTimeCount = getTotalWaiting(allTimeData);
    const tomorrowCount = getTotalWaiting(tomorrowData);
    const yesterdayCount = allTimeCount - todayCount - tomorrowCount;

    return {
      todayCount,
      yesterdayCount: Math.max(0, yesterdayCount), // Ensure non-negative
    };
  }, [isTask, data]);

  return (
    <Card className="p-4 mb-4">
      <Typography variant="body1" className="font-semibold mb-2">
        Key-In
      </Typography>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="col-span-1" style={cardStyle}>
          <div className="flex flex-col gap-1">
            <div className="text-sm font-bold text-gray-400">KEY-IN TODAY</div>
            <div className="text-3xl font-bold">{todayCount}</div>
          </div>
        </div>
        <div className="col-span-1" style={cardStyle}>
          <div className="flex flex-col gap-1">
            <div className="text-sm font-bold text-error">KEY-IN YESTERDAY</div>
            <div className="text-3xl font-bold text-error-dark">
              {yesterdayCount}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
});

KeyIn.displayName = "KeyIn";

export default KeyIn;
